const SchemeNames = {
    mc: 'Mastercard',
    visa: 'Visa'
};

export { SchemeNames };
